<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="font-weight: bold;"><i class="el-icon-data-line text-blue" style="margin-right: 5px;"></i>{{title}}</span>
      <i :class="isExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" class="expand-icon" @click="toggleExpand"></i>
    </div>

    <div v-show="isExpanded" v-loading="loading">
      <el-row :gutter="20" class="data-row">
        <el-col :span="4">
          <div class="data-item">
            <div class="data-content">
              <div class="label">总流量</div>
              <div class="value">{{ data.totalTraffic }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="data-item">
            <div class="data-content">
              <div class="label">总客户数</div>
              <div class="value">{{ data.totalCustomers }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="data-item">
            <div class="data-content">
              <div class="label">总成交项目</div>
              <div class="value">{{ data.totalProjects }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="data-item">
            <div class="data-content">
              <div class="label">意向客户数</div>
              <div class="value text-orange">{{ data.intentionCustomers }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="data-item">
            <div class="data-content">
              <div class="label">潜在客户数</div>
              <div class="value text-blue">{{ data.potentialCustomers }}</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-divider content-position="left">转化率概览</el-divider>

      <el-row :gutter="20" class="data-row">
        <el-col :span="6">
          <div class="rate-item">
            <el-progress type="dashboard" :stroke-width="10" :percentage="Math.min(100,Number(data.totalConversionRate))" define-back-color="#eff5fb" color="#90c7ff" :format="() => `${Number(data.totalConversionRate) || 0}%`"></el-progress>
            <div class="rate-label">总转化率</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="rate-item">
            <el-progress type="dashboard" :stroke-width="10" :percentage="Math.min(100, Number(data.last30DaysConversionRate))" define-back-color="#e9f9ee" color="#6af895" :format="() => `${Number(data.last30DaysConversionRate) || 0}%`"></el-progress>
            <div class="rate-label">近30天转化率</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="rate-item">
            <el-progress type="dashboard" :stroke-width="10" :percentage="Math.min(100,Number(data.last60DaysConversionRate))" define-back-color="#f7f9e9" color="#e6e44d" :format="() => `${Number(data.last60DaysConversionRate) || 0}%`"></el-progress>
            <div class="rate-label">近60天转化率</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="rate-item">
            <el-progress type="dashboard" :stroke-width="10" :percentage="Math.min(100,Number(data.last90DaysConversionRate))" define-back-color="#fbf5ef" color="#fdb778" :format="() => `${Number(data.last90DaysConversionRate) || 0}%`"></el-progress>
            <div class="rate-label">近90天转化率</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'TrafficConversion',
  props: {
    targetType: {
      type: String,
      default: 'personal'
    },
    url: {
      type: String,
      default: 'zhaoshang/zhuanyuan/trafficConversion'
    },
    employeeId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isExpanded: true,
      loading: false,
      data: {
        totalTraffic: 0,
        totalCustomers: 0,
        totalProjects: 0,
        intentionCustomers: 0,
        potentialCustomers: 0,
        totalConversionRate: 0,
        last30DaysConversionRate: 0,
        last60DaysConversionRate: 0,
        last90DaysConversionRate: 0
      }

    }
  },
  created () {
    // this.fetchData()
  },
  computed: {
    title () {
      if (this.targetType === 'group') {
        return '团队流量 & 转化率'
      } else if (this.targetType === 'department') {
        return '部门流量 & 转化率'
      }
      return '个人流量 & 转化率'
    }
  },
  watch: {
    employeeId: {
      handler () {
        if (this.employeeId) {
          this.fetchData()
        }
      },
      immediate: true
    }
  },
  methods: {
    toggleExpand () {
      this.isExpanded = !this.isExpanded
    },
    async fetchData () {
      this.loading = true

      const params = {
        targetType: this.targetType
      }

      if (this.employeeId) {
        params.employeeId = this.employeeId
      }

      try {
        const { data: res } = await this.$http.get(this.url, { params })
        if (res.meta.status === 200) {
          this.data = res.data
        } else {
          this.$message.error(res.meta.msg)
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取流量转化率数据失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.text-blue { color: #409EFF; }
.clearfix {
  position: relative;
}
.expand-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #909399;
  transition: all 0.3s;
}
.expand-icon:hover {
  color: #409EFF;
}
.data-row {
  margin-bottom: 20px;
}
.data-item {
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}
.data-item:hover {
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.data-content {
  text-align: left;
  width: 100%;
}
.data-item .label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 4px;
}
.data-item .value {
  font-size: 22px;
  font-weight: bold;
  color: #303133;
  line-height: 1.2;
}
.text-orange { color: #e6a23c; }
.text-blue { color: #1989fa; }

.rate-item {
  text-align: center;
}
.rate-label {
  margin-top: 10px;
  font-size: 14px;
  color: #606266;
}
</style>
